import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import CareerDegreeSearch from './CareerDegreeSearch';
import {
  getTenantCareers,
  getCareerBasicsForTenant,
  toggleBrightOutlookCareerSearch,
} from '../../store/actions';
import { getCategoryImages } from '../utility/getCategoryImages';
import {
  getOnboardingState,
  getAuthState,
  showBrightCareersOnly,
  getTenantState,
} from '../../store/selectors';
import WindowTitle from '../utility/WindowTitle';

class CareerSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fullCareerList: '',
    };
  }

  async componentDidMount() {
    const response = await this.props.getCareerBasicsForTenant(
      this.props.tenant.id
    );
    this.setState({
      fullCareerList: response,
    });
  }

  getBrightOutlookCareers = () => {
    if (this.state.fullCareerList) {
      return this.state.fullCareerList.filter((eachCareer) => {
        return !!eachCareer.outlook;
      });
    }
    return [];
  };

  getListToShow = () => {
    if (this.props.showBrightOutlookCareersOnly)
      return this.getBrightOutlookCareers();
    return this.state.fullCareerList;
  };

  setListToShow = () => {
    this.props.toggleBrightOutlookCareerSearch();
  };

  render() {
    const listToShow = this.getListToShow();

    return (
      <>
        <Translation>
          {(t) => (
            <>
              <WindowTitle>{t('Search Careers')}</WindowTitle>
              <CareerDegreeSearch
                tenant={this.props.tenant}
                careerList={listToShow}
                inputText={t('Enter Career')}
                careerOrDegree="career"
                setListToShow={this.setListToShow}
                // setBrightOutlookModal={this.setBrightOutlookModal}
              />
            </>
          )}
        </Translation>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const tenant = getTenantState(state);
  const showBrightOutlookCareersOnly = showBrightCareersOnly(state);

  return { onboarding, auth, showBrightOutlookCareersOnly, tenant };
};

export default withRouter(
  connect(mapStateToProps, {
    getTenantCareers,
    toggleBrightOutlookCareerSearch,
    getCareerBasicsForTenant,
  })(CareerSearch)
);
